/* eslint-disable react/prop-types */
import Map, { ApiKey } from "devextreme-react/map";

function Maps({ property }) {
  const lat = property.gps_lat;
  const lng = property.gps_lng;
  const pName = property.name;

  const data = [
    {
      location: `${lat}, ${lng}`,
      tooltip: {
        text: `${pName}`,
      },
    },
  ];

  return (
    <>
      <Map
        defaultZoom={11}
        height={560}
        width="100%"
        controls
        markerIcon={<span className="material-icons-outlined">location_on</span>}
        markers={data}
        provider="bing"
      >
        <ApiKey google="MY_GOOGLE_MAPS_KEY" />
      </Map>
    </>
  );
}

export default Maps;
